import React from 'react';

import './privacy-policy.scss';

export const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <h1 className="privacy-policy__title">Privacy Policy</h1>
      <p className="privacy-policy__text">Effective Date: 2 October 2026</p>
      <p className="privacy-policy__text">
        Instant Meals Shop (“we”, “us”, “our”) respects your privacy and complies with POPIA.
      </p>
      <h2 className="privacy-policy__subtitle">Personal Data Collected</h2>
      <ul className="privacy-policy__list">
        <li>Name</li>
        <li>Email address</li>
        <li>Phone number</li>
        <li>Address</li>
        <li>IP address</li>
        <li>Order history</li>
        <li>Tokenized payment info</li>
        <li>Cookie identifiers, pages visited, and shopping activity on our sites</li>
      </ul>
      <h2 className="privacy-policy__subtitle">Purpose of Data</h2>
      <p className="privacy-policy__text">
        Used for processing orders, managing accounts, marketing communications (if subscribed),
        analytics, and measuring and improving our advertising.
      </p>
      <h2 className="privacy-policy__subtitle">Sharing Your Data</h2>
      <p className="privacy-policy__text">
        Shared with payment processors (PayFast), delivery personnel, email marketing tools,
        analytics providers, and Meta Platforms (Facebook and Instagram) through the Meta Pixel, but only
        if you accept cookies.
      </p>
      <h2 className="privacy-policy__subtitle">Cookies and the Meta Pixel</h2>
      <p className="privacy-policy__text">
        We use cookies to remember your cookie choice. If you click Accept on our cookie banner, we
        also use the Meta Pixel. It sends information about your visit (pages viewed, items added to
        your cart, and completed orders) to Meta, which we use to measure our advertising and show
        our ads to people who may be interested. If you click Decline, the Meta Pixel does not send
        data. Your choice is saved for one year and applies to both www.instant-meals.co.za and
        shop.instant-meals.co.za. You can change it at any time by clearing your browser cookies for
        these sites, which shows the banner again.
      </p>
      <h2 className="privacy-policy__subtitle">Data Storage</h2>
      <p className="privacy-policy__text">
        Stored securely on Azure and Firebase; may be outside South Africa.
      </p>
      <h2 className="privacy-policy__subtitle">Your Rights</h2>
      <p className="privacy-policy__text">
        Access, correct, or request deletion by contacting
        <a href="mailto:info@instant-meals.co.za"> info@instant-meals.co.za</a>.
      </p>
    </div>
  );
};
